import JSBridge from '@xpeng/js-bridge'
import Axios from '@/utils/axios'
import { getClientEnv } from '@/utils/common'
import { RequiredParams } from '../types'

const mockPrefix = 'http://mock.test.xiaopeng.local/mock/334'

const urlPrefixMap = {
  // 'dev': 'https://apigw.dm-dev.xiaopeng.com/sp-vowner-mapp',
  // 'dev': 'https://apigw.dm.xiaopeng.com/sp-vowner-mapp',
  'dev': mockPrefix,
  'test': 'https://apigw.dm-dev.xiaopeng.com/sp-vowner-mapp',
  'deploy': 'https://apigw.dm-pre.xiaopeng.com/sp-vowner-mapp',
  'product': 'https://apigw.dm.xiaopeng.com/sp-vowner-mapp'
}
const urlPrefix = urlPrefixMap[getClientEnv()]

/**
 * 通过APP发起对mona网关的请求
 * @param url url path
 * @param params vin必填
 */
export const monaRequest = (url: string, params: RequiredParams, method = 'POST') => {
  if (process.env.NODE_ENV === 'development') {
    return new Promise<any>((resolve, reject) => {
      Axios({
        url: `${mockPrefix}${url}`,
        method,
        params: method === 'GET' ? params : {},
        data: params,
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }

  return new Promise<any>((resolve, reject) => {
    JSBridge.callHandler('monaRequest', {
      url: `${urlPrefix}${url}`,
      options: {
        method,
        body: {
          ...params
        }
      }
    })
    .then(res => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * 关闭当前webview
 */
export function closeWebview() {
  JSBridge.callHandler('closeWindow')
}